/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SuggestedPrompt } from './SuggestedPrompt';
import {
    SuggestedPromptFromJSON,
    SuggestedPromptFromJSONTyped,
    SuggestedPromptToJSON,
    SuggestedPromptToJSONTyped,
} from './SuggestedPrompt';

/**
 * 
 * @export
 * @interface ListSuggestedPromptsResponse
 */
export interface ListSuggestedPromptsResponse {
    /**
     * 
     * @type {Array<SuggestedPrompt>}
     * @memberof ListSuggestedPromptsResponse
     */
    suggestedPrompts: Array<SuggestedPrompt>;
}

/**
 * Check if a given object implements the ListSuggestedPromptsResponse interface.
 */
export function instanceOfListSuggestedPromptsResponse(value: object): value is ListSuggestedPromptsResponse {
    if (!('suggestedPrompts' in value) || value['suggestedPrompts'] === undefined) return false;
    return true;
}

export function ListSuggestedPromptsResponseFromJSON(json: any): ListSuggestedPromptsResponse {
    return ListSuggestedPromptsResponseFromJSONTyped(json, false);
}

export function ListSuggestedPromptsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSuggestedPromptsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestedPrompts': ((json['suggestedPrompts'] as Array<any>).map(SuggestedPromptFromJSON)),
    };
}

export function ListSuggestedPromptsResponseToJSON(json: any): ListSuggestedPromptsResponse {
    return ListSuggestedPromptsResponseToJSONTyped(json, false);
}

export function ListSuggestedPromptsResponseToJSONTyped(value?: ListSuggestedPromptsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'suggestedPrompts': ((value['suggestedPrompts'] as Array<any>).map(SuggestedPromptToJSON)),
    };
}

